import { Observable, ObservableInputTuple, combineLatest } from 'rxjs';
import { tag } from 'rxjs-spy/operators';

/**
 * Make this stream a derived stream of its source and dependencies
 *
 * This is basically an annotated version of the `combineLatest` operator that
 * adds tags so the stream can be analyzed.
 *
 * @param name The unique name of this stream
 * @param dependencies The dependencies of this stream
 * @see combineLatest
 */
export const derivedStream = <T extends readonly unknown[]>(
  name: string,
  ...dependencies: readonly [...ObservableInputTuple<T>]
): Observable<T> => combineLatest(dependencies).pipe(tag(name));
